import { ref, reactive, computed, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addBlackSetting, updateBlackSetting } from '@/api/blackApi';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlackModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null
  },
  emits: ['update:modalVisible', 'update:editItem', 'refreshList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const rules = {
      deviceId: [{
        required: true,
        message: '请输入设备号',
        trigger: 'blur'
      }]
    };
    const visible = ref(false);
    const orderForm = reactive({
      deviceId: ''
    });
    const orderRef = ref(null);
    const closeModal = () => {
      var _orderRef$value;
      Object.assign(orderForm, initForm());
      (_orderRef$value = orderRef.value) === null || _orderRef$value === void 0 || _orderRef$value.clearValidate();
      emit('update:modalVisible', false);
      emit('update:editItem', {});
    };
    const initForm = () => {
      return {
        deviceId: '',
        id: '',
        createUser: '',
        createTime: ''
      };
    };
    const submitModal = () => {
      var _JSON$parse, _orderRef$value2;
      let name = (_JSON$parse = JSON.parse(userInfo.value)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.name;
      (_orderRef$value2 = orderRef.value) === null || _orderRef$value2 === void 0 || _orderRef$value2.validate().then(async () => {
        let params = {},
          fn;
        if (orderForm.id) {
          params = {
            id: orderForm.id,
            deviceId: orderForm.deviceId
          };
          fn = updateBlackSetting;
        } else {
          params = {
            deviceId: orderForm.deviceId,
            userName: name
          };
          fn = addBlackSetting;
        }
        try {
          const {
            code,
            msg
          } = await fn(params);
          if (code === OK) {
            message.success(msg);
            closeModal();
            emit('refreshList');
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '黑名单查询',
                element_name: '配置保存'
              }
            });
          }
        } catch (error) {}
      }).catch(err => {});
    };
    const userInfo = computed(() => sessionStorage.getItem('userInfo') || '');
    watch(() => props.modalVisible, n => {
      visible.value = n;
    }, {
      immediate: true
    });
    watch(() => props.editItem, n => {
      if (typeof n === 'object') {
        Object.assign(orderForm, n);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "黑名单配置",
        onCancel: closeModal,
        onOk: submitModal,
        centered: "",
        open: visible.value,
        "onUpdate:open": _cache[1] || (_cache[1] = $event => visible.value = $event),
        width: "523px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "order",
          model: orderForm,
          ref_key: "orderRef",
          ref: orderRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "设备号：",
            name: "deviceId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: orderForm.deviceId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => orderForm.deviceId = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入设备号"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});